import React from 'react';
import { useNavigate } from 'react-router-dom';
import { canSeeEntry } from '../utils';
import { NAV } from '../navConfig';

export default function ExpenseMasterPage({ user }) {
  const navigate = useNavigate();

  // The cards are the module's `links` in navConfig (also its sidebar submenu). The All-In-One
  // Expense Register is open to everyone, so this page is too.
  const cards = NAV.flatMap(g => g.items).find(i => i.id === 'expense-master').links
    .filter(c => canSeeEntry(user, c))
    .map(c => ({ ...c, title: c.label, route: c.to }));

  return (
    <div className="fade-in" style={{ padding: '24px 26px' }}>
      <div style={{ marginBottom: 20 }}>
        <p style={{ fontSize: 14, color: 'var(--text-secondary)', margin: 0 }}>
          Select an expense category below.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 16 }}>
        {cards.map(card => (
          <div
            key={card.id}
            onClick={() => {
              navigate(card.route);
            }}
            style={{
              background: '#e2e8f0',
              border: '2px solid #000',
              borderRadius: '12px',
              padding: '24px',
              cursor: 'pointer',
              boxShadow: '0 15px 30px rgba(0, 0, 0, 0.55)',
              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              display: 'flex', flexDirection: 'column', gap: 12
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = '#cbd5e1';
              e.currentTarget.style.borderColor = 'var(--accent)';
              e.currentTarget.style.boxShadow = '0 36px 64px rgba(0, 0, 0, 0.65)';
              e.currentTarget.style.transform = 'translateY(-6px)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = '#e2e8f0';
              e.currentTarget.style.borderColor = '#000';
              e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.55)';
              e.currentTarget.style.transform = 'none';
            }}
          >
            <div style={{ fontSize: 32 }}>
              {card.icon}
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>{card.title}</div>
                {card.route.includes('coming-soon') && (
                  <span style={{ fontSize: 10, fontWeight: 700, background: '#cbd5e1', color: '#475569', padding: '2px 8px', borderRadius: 999 }}>Coming Soon</span>
                )}
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{card.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
